import { Environment } from '../app/core/models/environment.model';

export const environment: Environment = {
  production: false,
  apiUrls: {
    identity: '/identity',
    bffAdmin: '/bff-admin-api',
    equipment: '/equipment-api',
  },
  telemetry: {
    staleDataTimeoutMinutes: 3,
  },
  auth: {
    issuer: 'https://qa-monitoring.hoststella.com/identity',
    redirectUri: 'https://qa-monitoring.hoststella.com/login/confirmation',
    clientId: 'admin_panel',
    dummyClientSecret: 'admin_secret_rrp_240913',
    responseType: 'code',
    scope: 'openid admin_panel_api identity_api offline_access',
    tokenEndpoint: 'https://qa-monitoring.hoststella.com/identity/connect/token',
    logoutUrl: 'https://qa-monitoring.hoststella.com/logout',
    postLogoutRedirectUri: 'https://qa-monitoring.hoststella.com',
    requireHttps: false,
  },
};
